import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PrivateRoutes } from './PrivateRoutes';
import { PublicRoutes } from './PublicRoutes';
import { loginSelector } from '../../features/loginSlice';
import { LOGIN_STATUS } from '../../utils/Constant';
import { updateSelectedMenu } from '../../features/dashboardSlice';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';

function AppRoute() {
  const dispatch = useAppDispatch();
  const loginStore = useAppSelector(loginSelector);
  const href = window.location.href;
  let path: string = href.split('#')[1];
  if (path) {
    path = path.replace('/', '');
  }
  if (
    path &&
    !path.includes('login') &&
    loginStore.status === LOGIN_STATUS.AUTHENTICATED
  ) {
    dispatch(updateSelectedMenu(path));
  } else if (!path && loginStore.status === LOGIN_STATUS.AUTHENTICATED) {
    dispatch(updateSelectedMenu('home'));
  }
  return (
    <Routes>
      {loginStore.status === LOGIN_STATUS.AUTHENTICATED ? (
        <Route path="/*" element={<PrivateRoutes />} />
      ) : (
        <Route path="/*" element={<PublicRoutes />} />
      )}
    </Routes>
  );
}
export default AppRoute;
